import { useEffect, useRef } from "react";

declare global {
  interface Window {
    Tawk_API?: Record<string, unknown>;
    Tawk_LoadStart?: Date;
  }
}

// Chat with support
const TawkTo = () => {
  const scriptLoadedRef = useRef(false);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const tawkSrc = process.env.GATSBY_TAWK_TO_SRC;

    if (!tawkSrc || scriptLoadedRef.current) {
      return;
    }

    scriptLoadedRef.current = true;

    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    const script = document.createElement("script");
    script.async = true;
    script.src = tawkSrc;
    script.charset = "UTF-8";
    script.setAttribute("crossorigin", "*");

    const firstScript = document.getElementsByTagName("script")[0];
    firstScript?.parentNode?.insertBefore(script, firstScript);

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
      delete window.Tawk_API;
      delete window.Tawk_LoadStart;
      scriptLoadedRef.current = false;
    };
  }, []);

  return null;
};

export default TawkTo;
